/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useRef, useState } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import TimePicker from 'rc-time-picker';
import { format } from 'date-fns';

const INITIAL_STEP = 1;

export default function InquiryForm({
  property,
  agent,
  current_user = {},
  pushDataInToDataLayer,
}) {
  const modalRef = useRef();

  const agentBroker =
    agent && agent.broker_company && agent.broker_company.id === 1
      ? 'RO'
      : 'non_RO';
  const agentName = agent
    ? `${agent.first_name} ${agent.last_name}`
    : 'an agent';
  const noCurrentUser = !current_user || !current_user.id;

  // Modal State
  const [step, setStep] = useState(INITIAL_STEP);
  const [inquiryType, setInquiryType] = useState('general');
  const [dateFocused, setDateFocused] = useState(false);
  // Form State
  const [formState, setFormState] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const formID = inquiryType === 'general' ? 'general-form' : 'tour-form';

    const inputSelector = document.querySelector(
      `#${formID} .inquiry_mls_listing_id input`
    );
    inputSelector.value = property.id;
  }, [inquiryType, property]);

  useEffect(() => {
    if (formState) {
      const formID = inquiryType === 'general' ? 'general-form' : 'tour-form';

      Object.entries(formState).forEach(([key, val]) => {
        const inputSelector = document.querySelector(
          `#${formID} .inquiry_${key} input`
        );

        if (key.includes('tour_date'))
          inputSelector.value = format(val, 'YYYY-MM-DD');
        if (key.includes('tour_time'))
          inputSelector.value = format(val, 'HH:mm:ss');
        inputSelector.value = val;
      });
    }
  }, [formState, inquiryType]);

  const handleInput = e => {
    if (errors[e.target.name]) {
      const errorsCopy = { ...errors };
      delete errorsCopy[e.target.name];
      setErrors(errorsCopy);
    }

    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleCustomInput = (name, val) => {
    if (errors[name]) {
      const errorsCopy = { ...errors };
      delete errorsCopy[name];
      setErrors(errorsCopy);
    }

    setFormState({ ...formState, [name]: val });
  };

  const handleSubmit = e => {
    e.preventDefault();

    const {
      first_name,
      last_name,
      email,
      phone,
      tour_date,
      tour_time,
      message,
    } = formState;

    let tempErrors = {};
    // Validation
    if (!first_name) tempErrors = { ...tempErrors, first_name: true };
    if (!last_name) tempErrors = { ...tempErrors, last_name: true };
    if (!email) tempErrors = { ...tempErrors, email: true };
    if (!phone) tempErrors = { ...tempErrors, phone: true };
    if (inquiryType === 'general') {
      if (!message) tempErrors = { ...tempErrors, message: true };
    } else {
      if (!tour_date) tempErrors = { ...tempErrors, tour_date: true };
      if (!tour_time) tempErrors = { ...tempErrors, tour_time: true };
    }

    if (Object.keys(tempErrors).length) {
      setErrors(tempErrors);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (inquiryType === 'general')
        document.querySelector('form#general-form #inquiry_submit').click();
      else if (inquiryType === 'tour')
        document.querySelector('form#tour-form #inquiry_submit').click();

      setStep(3);
    }

    pushDataInToDataLayer();
  };

  const hideForm = () => {
    if (modalRef.current) modalRef.current.classList.add('hidden');
  };

  const clearForm = () => {
    setStep(INITIAL_STEP);
    setFormState({});
    setInquiryType('general');
    setErrors({});
  };

  const inquiryFormTextOptions = {
    // Is Realty One
    RO: {
      initialSubtitle: `Would you like to send ${agentName} a general message or schedule a property tour?`,
      generalSubtitle: `Have a question about ${property.address}? Fill out this form and ${agentName} will connect with you as soon as possible.`,
      propertySubtitle: `Want to schedule a tour of ${property.address}? Fill out this form and ${agentName} will connect with you as soon as possible.`,
    },
    // Is NOT Realty One
    non_RO: {
      initialSubtitle: `Would you like to send a general message or schedule a property tour?`,
      generalSubtitle: `Have a question about ${property.address}? Fill out this form and ${agentName} will connect with you as soon as possible.`,
      propertySubtitle: `Want to schedule a tour of ${property.address}? Fill out this form and ${agentName} will connect with you as soon as possible.`,
    },
    general: {
      title: 'General Message',
      subTitle: `Have a question about ${property.address}? Fill out this form and ${agentName} will connect with you as soon as possible.`,
      successTitle: `Your inquiry has been submitted`,
      successSubtitle: `${agentName.charAt(0).toUpperCase() +
        agentName.slice(1)} will connect with you as soon as possible.`,
    },
    tour: {
      title: 'Property Tour',
      subTitle: `Want to schedule a tour of ${property.address}? Fill out this form and ${agentName} will connect with you as soon as possible.`,
      successTitle: `Your request has been submitted`,
      successSubtitle: `${agentName.charAt(0).toUpperCase() +
        agentName.slice(1)} will connect with you as soon as possible.`,
    },
  };

  return (
    <aside
      id="mls-inquiry-modal"
      ref={modalRef}
      className="modal-container hidden"
    >
      <div className="modal-backdrop" />

      <div className="modal mls-inquiry">
        <div className="outer mls-form-image">
          <img data-src={property.images[0]} alt="" className="lazyload" />
        </div>

        {/* Step 1: General vs Tour select */}
        {step === 1 && (
          <section className="mls-form-container">
            <h3 className="form-title">Contact Agent</h3>
            <p className="form-subtitle">
              {inquiryFormTextOptions[agentBroker].initialSubtitle}
            </p>

            <div className="radio-buttons-container">
              <button
                type="button"
                className={`radio-button ${
                  inquiryType === 'general' ? 'selected' : ''
                }`}
                onClick={() => setInquiryType('general')}
              >
                <div className="radio-input" />
                <p>Send a general message</p>
              </button>

              <button
                type="button"
                className={`radio-button ${
                  inquiryType === 'tour' ? 'selected' : ''
                }`}
                onClick={() => setInquiryType('tour')}
              >
                <div className="radio-input" />
                <p>Schedule a property tour</p>
              </button>
            </div>

            <div className="form-actions-container">
              <button
                type="button"
                aria-label="Next"
                title="Next"
                className="btn btn--blue-grad"
                onClick={() => {
                  setStep(step + 1);
                }}
              >
                Next
              </button>
              <button
                type="button"
                aria-label="Cancel"
                title="Cancel"
                className="btn btn--link"
                onClick={() => {
                  clearForm();
                  hideForm();
                }}
              >
                Cancel
              </button>
            </div>
          </section>
        )}

        {/* Step 2: Inquiry Form */}
        {step === 2 && (
          <form className="mls-form-container" onSubmit={handleSubmit}>
            <h3 className="form-title">
              {inquiryFormTextOptions[inquiryType].title}
            </h3>
            <p className="form-subtitle">
              {inquiryFormTextOptions[inquiryType].subTitle}
            </p>

            <fieldset>
              <div
                className={`input ${
                  errors.first_name ? 'field_with_errors' : ''
                }`}
              >
                <label htmlFor="first_name" className="input">
                  First name*
                </label>
                <input
                  type="first_name"
                  id="first_name"
                  name="first_name"
                  placeholder="Enter your first name"
                  value={formState.first_name}
                  onChange={handleInput}
                />
                {errors.first_name && (
                  <span className="error">First name can't be blank</span>
                )}
              </div>

              <div
                className={`input ${
                  errors.last_name ? 'field_with_errors' : ''
                }`}
              >
                <label htmlFor="last_name" className="input">
                  Last name*
                </label>
                <input
                  type="last_name"
                  id="last_name"
                  name="last_name"
                  placeholder="Enter your last name"
                  value={formState.last_name}
                  onChange={handleInput}
                />
                {errors.last_name && (
                  <span className="error">Last name can't be blank</span>
                )}
              </div>

              <div
                className={`input ${errors.email ? 'field_with_errors' : ''}`}
              >
                <label htmlFor="email" className="input">
                  Email address*
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={formState.email}
                  onChange={handleInput}
                />
                {errors.email && (
                  <span className="error">Email can't be blank</span>
                )}
              </div>

              <div
                className={`input ${errors.phone ? 'field_with_errors' : ''}`}
              >
                <label htmlFor="phone" className="input">
                  Phone number*
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Enter your phone number"
                  value={formState.phone}
                  onChange={handleInput}
                />
                {errors.phone && (
                  <span className="error">Phone number can't be blank</span>
                )}
              </div>

              {inquiryType === 'general' ? (
                <div
                  className={`input ${
                    errors.message ? 'field_with_errors' : ''
                  }`}
                >
                  <label htmlFor="message" className="input">
                    Message*
                  </label>
                  <textarea
                    // type="textarea"
                    id="message"
                    name="message"
                    placeholder="Enter your message"
                    value={formState.message}
                    onChange={handleInput}
                  />
                  {errors.message && (
                    <span className="error">Message can't be blank</span>
                  )}
                </div>
              ) : (
                <>
                  <div
                    className={`input ${
                      errors.tour_date ? 'field_with_errors' : ''
                    }`}
                  >
                    <label htmlFor="tour_date" className="input">
                      Preferred date*
                    </label>
                    <SingleDatePicker
                      id="tour_date"
                      numberOfMonths={1}
                      openDirection="up"
                      noBorder
                      focused={dateFocused}
                      placeholder="Select your preferred date"
                      onFocusChange={({ focused }) => setDateFocused(focused)}
                      date={formState.tour_date}
                      onDateChange={date =>
                        handleCustomInput('tour_date', date)
                      }
                    />
                    {errors.tour_date && (
                      <span className="error">Date can't be blank</span>
                    )}
                  </div>

                  <div
                    className={`input ${
                      errors.tour_time ? 'field_with_errors' : ''
                    }`}
                  >
                    <label htmlFor="tour_time" className="input">
                      Preferred time*
                    </label>
                    <TimePicker
                      inputReadOnly
                      value={formState.tour_time}
                      placeholder="Select your preferred time"
                      use12Hours
                      showSecond={false}
                      format="h:mm a"
                      allowEmpty={false}
                      onChange={time => {
                        handleCustomInput('tour_time', time);
                      }}
                      popupClassName="custom-time-picker"
                    />
                    {errors.tour_time && (
                      <span className="error">Time can't be blank</span>
                    )}
                  </div>
                </>
              )}
            </fieldset>

            <div className="form-actions-container">
              <button
                type="submit"
                aria-label="Submit"
                title="Submit"
                className="btn btn--blue-grad"
              >
                Submit
              </button>
              <button
                type="button"
                aria-label="Cancel"
                title="Cancel"
                className="btn btn--link"
                onClick={() => {
                  clearForm();
                  hideForm();
                }}
              >
                Cancel
              </button>
            </div>

            {noCurrentUser && (
              <p className="modal-notice">
                We noticed you aren’t logged in or might not have an account
                yet. By submitting this inquiry, you agree to having a temporary
                account created using the above information if one doesn’t exist
                already.
              </p>
            )}
          </form>
        )}

        {/* Step 3: Success Message */}
        {step === 3 && (
          <section className="mls-form-container">
            <h3 className="form-title">
              {inquiryFormTextOptions[inquiryType].successTitle}
            </h3>
            <p className="form-subtitle">
              {inquiryFormTextOptions[inquiryType].successSubtitle}
            </p>

            {noCurrentUser && (
              <p className="form-subtitle">
                A temporary account has been created for you. Please check your
                email to complete the sign up process.
              </p>
            )}

            <div className="form-actions-container">
              <button
                type="submit"
                aria-label="Submit"
                title="Submit"
                className="btn btn--blue-grad"
                onClick={() => {
                  hideForm();
                }}
              >
                Close
              </button>
            </div>
          </section>
        )}
      </div>
    </aside>
  );
}
